import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import { GUIDES, GUIDE_CATEGORIES } from '../../data/guides';
import './ContentPage.css';

const Guides = () => {
  const { t } = useTranslation();
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered =
    activeCategory === 'All'
      ? GUIDES
      : GUIDES.filter((g) => g.category === activeCategory);

  return (
    <div className="content-page guides-page">
      <PageMeta
        title={t('guides.pageTitle')}
        description={t('guides.pageDescription')}
        path="/guides"
      />
      <Header />
      <header className="content-hero">
        <div className="content-hero-inner">
          <h1 className="content-hero-title">{t('guides.pageTitle')}</h1>
          <p className="content-hero-desc">{t('guides.pageDescription')}</p>
        </div>
      </header>

      <p className="guides-intro">{t('guides.intro')}</p>

      <div className="guides-categories">
        <button
          type="button"
          className={`guides-cat-btn ${activeCategory === 'All' ? 'active' : ''}`}
          onClick={() => setActiveCategory('All')}
        >
          {t('guides.allCategories')}
        </button>
        {GUIDE_CATEGORIES.map((cat) => (
          <button
            key={cat}
            type="button"
            className={`guides-cat-btn ${activeCategory === cat ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="guides-grid">
        {filtered.map((guide) => (
          <Link key={guide.slug} to={`/guides/${guide.slug}`} className="guide-card">
            <span className="guide-card-category">{guide.category}</span>
            <h2 className="guide-card-title">{guide.title}</h2>
            <p className="guide-card-desc">{guide.description}</p>
            <span className="guide-card-meta">
              {guide.readTimeMinutes} min read · {guide.publishedAt}
            </span>
          </Link>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Guides;
